import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

const useLabelStyles = makeStyles({
  input: {
    padding: 'clamp(2.3px, 0.29vw, 3.8px) clamp(2px, 0.15vw, 8px) !important',
    fontSize: 'clamp(0.69rem, 1.04vw, 0.90rem)',
    color: '#002D55',
    borderRadius: 14,
    background: 'transparent',
    fontWeight: 500,
    '&::placeholder': {
      color: '#002D55',
      fontWeight: 'normal',
      fontSize: 'clamp(0.69rem, 0.90rem)',
      letterSpacing: '0.1px',
      opacity: 1,
      transition: 'opacity 0.2s',
    },
    '&:focus::placeholder': {
      opacity: 0.3,
    },
  },
  responsiveOption: {
    fontSize: 'clamp(0.69rem, 0.69vw, 0.93rem)',
    color: '#002D55',
  },
  paper: {
    borderRadius: 14,
  },
  orangeFocused: {
    '& .MuiOutlinedInput-root': {
      padding: '1px !important',
      fontSize: 'clamp(0.69rem, 1.04vw, 0.90rem)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ccc',
      borderRadius: 14,
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
      borderWidth: 1,
    },
  },
});

const AdviceSearchbar = ({className, advices, searchInput, setSearchInput, disabled}) => {
  const labelClasses = useLabelStyles();
  const classes = labelClasses;

  return (
    <div style={{ width: '50%', minWidth: 0, maxWidth: 800, backgroundColor: "transparent", margin: '0 auto', paddingLeft: "1.5%" }}>
      <Autocomplete
        freeSolo
        options={advices}
        disableClearable={false}
        inputValue={searchInput}
        classes={{ paper: labelClasses.paper }}
        onChange={(event, option) => {
          if (option && typeof option === 'object') setSearchInput(option.title);
        }}
        onInputChange={(event, newValue, reason) => {
          if (reason === 'reset') return;
          if (reason === 'clear') { setSearchInput(''); return; }
          setSearchInput(newValue);
        }}
        getOptionLabel={(option) => `${option.title}`}
        renderOption={(option) => (
          <div className={labelClasses.responsiveOption}>{option.title}</div>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            className={`${classes.orangeFocused || ''} ${className || ''}`}
            placeholder='Search Advice'
            variant="outlined"
            margin="none"
            InputProps={{
              ...params.InputProps,
              type: 'text',
              disabled,
              classes: { input: labelClasses.input },
              style: { backgroundColor: '#FFF', borderRadius: 14, overflow: 'hidden' },
              startAdornment: (
                <InputAdornment position="start" style={{ marginLeft: 6 }}>
                  <SearchIcon style={{ fontSize: 16, color: '#002D55', opacity: 0.5 }} />
                </InputAdornment>
              ),
            }}
            onKeyDown={event => {
              if (event.key === 'Escape') {
                setSearchInput('');
              }
            }}
          />
        )}
      />
    </div>
  );
}

export default AdviceSearchbar